import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout, { staticSidePanelSignal } from "../layout/Layout";
import EntityView from "../layout/EntityView/EntityView";
import GetSchema, { hasVisibleChildren } from "../entityComponents/Schema";
import { httpGet } from "../../../modules/Backend";
import { LowerCase, SingularUpperCase } from "../../../helpers/EntityNameHelper";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";
import { useMainConfig } from "../../../modules/config/MainConfigContext";

export default function ViewPage() {
    const { entityName, entityId } = useParams();

    return (
        <ViewPageContent key={entityId} entityName={entityName!} entityId={entityId!}/>
    )
}

function ViewPageContent({entityName, entityId} : {entityName :string, entityId : string}) {
    const { config } = useMainConfig();
    const schema = GetSchema(entityName!, config || undefined);
    const permissionsContext = usePermissions();
    const navigate = useNavigate();

    const [data, Setdata] = useState<any>(undefined)
    const [pageTitle, setPageTitle] = useState<string>()

    async function getData() {
        const result = await httpGet(`api/${entityName}/get?id=${entityId}`)

        if (result.data && schema) {
            Setdata(result.data)
            const descriptor = schema.props.find(x => x.descriptor === true)?.name;
            const entityDisplayName = SingularUpperCase(LowerCase(schema.displayName));
            const displayValue = result.data[descriptor!] || "";
            setPageTitle(`${entityDisplayName} - ${displayValue}`)
        }
    }

    useEffect(() => {
        getData()
    }, [entityId])

    useEffect(() => {
        if(schema && schema.GetSidePanelComponent && data ){
            staticSidePanelSignal.value = schema.GetSidePanelComponent({...data, entityName: entityName}, true)
        }
        else {
            staticSidePanelSignal.value = undefined
        }
    }, [data])

    // Redirect if no visible children
    useEffect(() => {
        if (permissionsContext && schema && schema.children && schema.children.length > 0 && !hasVisibleChildren(entityName, permissionsContext)) {
            // Navigate back - could also show an error message
            navigate(-1);
        }
    }, [permissionsContext, schema, entityName, entityId, navigate])

    // Don't render EntityView if there are no visible children
    if (!schema) {
        return null;
    }

    if (permissionsContext && schema.children && schema.children.length > 0 && !hasVisibleChildren(entityName, permissionsContext)) {
        return null;
    }

    return (
        <>
            <Layout entityName={entityName!} data={data} pageTitle={pageTitle ? pageTitle : ""} showBackButton={true} showBreadcrumb={false} key={entityName + "Layout"} canScroll={false}>
                {entityName && entityId && <EntityView entityName={entityName} entityId={entityId} />}
            </Layout>
        </>)
}